import React, { useState, useEffect } from "react";
import { Modal, ModalBody, Row, Col, Input, FormFeedback } from "reactstrap";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormField from "../../../../components/FormField/FormField";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

const validation = Yup.object().shape({
  first_name: Yup.string().required("First name is required."),
  last_name: Yup.string().required("Last name is required."),
  phone: Yup.string().required("Phone is required."),
  email: Yup.string()
    .matches(
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
      "Please enter valid email"
    )
    .required("Email is required"),
});

let initialValues = {
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  address_line_1: "",
  country_id: "",
  state: "",
  city: "",
  zip: "",
};

const EditModal = (props) => {
  const [formValues, setFormValues] = useState(null);

  useEffect(() => {
    console.log(props);

    setFormValues({
      ...props.data,
      country_id: props.data.country ? props.data.country.value : "",
    });
  }, []);

  return (
    <>
      <Modal
        isOpen={props.showEditModal}
        toggle={props.handleClose}
        className="event-modal modal-lg modal-dialog"
      >
        <ModalBody>
          <div className="">
            <div className="box_content">
              <div className="rd_inputselectheadermodalsetting">
                <button
                  className="rd_colsebtn"
                  onClick={props.handleClose}
                ></button>
              </div>

              <h5 className="rd_modalheadertext rd_modalheadertextnm">
                Edit Customer
              </h5>

              <Formik
                validationSchema={validation}
                initialValues={formValues || initialValues}
                enableReinitialize
                onSubmit={(values) => {
                  const { onUpdateRecord } = props;
                  let formData = {
                    ...values,
                  };

                  props.handleClose();
                  onUpdateRecord(formData);
                }}
              >
                {(formProps) => {
                  const {
                    values,
                    errors,
                    touched,
                    handleChange,
                    setFieldValue,
                    setFieldTouched,
                  } = formProps;
                  return (
                    <Form>
                      <Row>
                        <Col lg="6" md="6">
                          <label className="same-label" htmlFor="coupon_code">
                            First Name *
                          </label>
                          <FormField
                            type="text"
                            name="first_name"
                            placeholder="First Name"
                            value={values.first_name}
                            errors={errors}
                            touched={touched}
                            onChange={({ target }) => {
                              const { value } = target;
                              handleChange({
                                target: { name: "first_name", value },
                              });
                            }}
                          />
                        </Col>

                        <Col lg="6" md="6">
                          <label className="same-label" htmlFor="coupon_code">
                            Last Name *
                          </label>
                          <FormField
                            type="text"
                            name="last_name"
                            placeholder="Last Name"
                            value={values.last_name}
                            errors={errors}
                            touched={touched}
                            onChange={({ target }) => {
                              const { value } = target;
                              handleChange({
                                target: { name: "last_name", value },
                              });
                            }}
                          />
                        </Col>
                      </Row>

                      <Row>
                        <Col lg="6" md="6">
                          <label className="same-label" htmlFor="coupon_code">
                            Email *
                          </label>
                          <FormField
                            type="text"
                            name="email"
                            placeholder="Email"
                            value={values.email}
                            errors={errors}
                            touched={touched}
                            onChange={({ target }) => {
                              const { value } = target;
                              handleChange({
                                target: { name: "email", value },
                              });
                            }}
                          />
                        </Col>

                        <Col lg="6" md="6">
                          <label className="same-label" htmlFor="coupon_code">
                            Phone
                          </label>
                          <PhoneInput
                            containerClass="custom_phn_inp"
                            country={"us"}
                            value={values.phone}
                            onBlur={() => {
                              setFieldTouched(`phone`, true);
                            }}
                            onChange={(value) => {
                              handleChange({
                                target: { name: "phone", value },
                              });
                            }}
                          />
                          {errors[`phone`] && touched[`phone`] && (
                            <FormFeedback className="d-block">
                              {errors[`phone`]}
                            </FormFeedback>
                          )}
                          {/* <FormField
                            type="text"
                            name="phone"
                            placeholder="Phone"
                            value={values.phone}
                            errors={errors}
                            touched={touched}
                            onChange={({ target }) => {
                              const { value } = target;
                              handleChange({
                                target: { name: "phone", value },
                              });
                            }}
                          /> */}
                        </Col>
                      </Row>

                      <Row>
                        <Col md="12" lg="12" className="pt-3">
                          <div className="form-group event-form-group">
                            <label>Address</label>
                            <Input
                              type="textarea"
                              className="form-control"
                              name="address_line_1"
                              placeholder="Address"
                              value={values.address_line_1}
                              onChange={({ target }) => {
                                const { name, value } = target || {};
                                handleChange({
                                  target: { name: "address_line_1", value },
                                });
                              }}
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg="6" md="6">
                          <label className="same-label" htmlFor="coupon_code">
                            Country
                          </label>
                          <FormField
                            placeholder="Country"
                            showPlaceholder={true}
                            type="select"
                            name="country_id"
                            errors={errors}
                            touched={touched}
                            options={props.countries}
                            value={values.country.value}
                          />
                        </Col>

                        <Col lg="6" md="6">
                          <label className="same-label" htmlFor="coupon_code">
                            State
                          </label>
                          <FormField
                            type="text"
                            name="state"
                            placeholder="State"
                            errors={errors}
                            touched={touched}
                            value={values.state}
                            onChange={({ target }) => {
                              const { value } = target;
                              handleChange({
                                target: { name: "state", value },
                              });
                            }}
                          />
                        </Col>
                      </Row>

                      <Row className="mb-5">
                        <Col lg="6" md="6">
                          <label className="same-label" htmlFor="coupon_code">
                            City
                          </label>
                          <FormField
                            type="text"
                            name="city"
                            placeholder="City"
                            errors={errors}
                            touched={touched}
                            value={values.city}
                            onChange={({ target }) => {
                              const { value } = target;
                              handleChange({
                                target: { name: "city", value },
                              });
                            }}
                          />
                        </Col>

                        <Col lg="6" md="6">
                          <label className="same-label" htmlFor="coupon_code">
                            Zip
                          </label>
                          <FormField
                            type="text"
                            name="zip"
                            placeholder="Zip"
                            errors={errors}
                            touched={touched}
                            value={values.zip}
                            onChange={({ target }) => {
                              const { value } = target;
                              handleChange({
                                target: { name: "zip", value },
                              });
                            }}
                          />
                        </Col>
                      </Row>

                      <div className="rd_cancelappbtnmodal">
                        <button
                          type="button"
                          className="rd_cancel"
                          onClick={props.handleClose}
                        >
                          Cancel
                        </button>
                        <button type="submit" className="btn btn-app">
                          Save
                        </button>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default EditModal;
